import { mpsEndpoints } from '../mps/mps-endpoints';

export const environment = {
  production: false,
  envName: 'dev',
  api: {
    host: 'https://api-oser-d.mpshp.alzp.tgscloud.net',
    providers: mpsEndpoints.providers,
  },
  loaderOnHttp: true,
  // Front public OSER : pas d'authentification. Désactive les initializers OAuth2
  // et la redirection login sur 401 (voir mps.config.ts).
  publicApp: true,
  defaultLocale: 'fr',
  allowedLanguage: ['fr', 'en'],
  appName: 'OSER',
  mpsIcons: ['bin', 'edit', 'gray-edit', 'user', 'info', 'pdf', 'pdf-file', 'three-dots', 'account-circle', 'search'],
  appIcons: [],
  translationsSource: 'local',
  allowImpersonation: false,
};
